/**
 * Default landing path after login / when a route is forbidden.
 * Managers land on Jobs; employees land on the first feature they can use.
 */
export const getAuthenticatedHomePath = (user) => {
	const isManager =
		Boolean(user?.isSuperuser) ||
		Boolean(user?.is_superuser) ||
		user?.role === 'Manager';
	if (isManager) {
		return '/jobs';
	}
	const features = user?.organization?.features || {};
	if (features.time_tracking) {
		return '/time';
	}
	if (features.scheduling) {
		return '/schedule';
	}
	// Employees without Pro features have no dedicated home; stay off Customers.
	return '/time';
};
